// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital@1&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background: rgba(247, 247, 247, 1);
}

.sidebar {
  background-color: #1549d6;
  min-width: 70px;
  height: auto;
}

.out-of-funds-btn {
  background-color: rgba(255, 0, 0, 1);
  border-radius: 5px;
  color: #fff;
  outline: none;
  border: none;
  text-align: center;
  width: 20%;
  min-width: fit-content;
  font-weight: bold;
  text-decoration: none;
  padding: 10px;
  font-size: 1em;
}

.out-of-funds-btn:hover {
  background-color: rgba(220, 0, 0, 1);
  color: #fff;
}

.reload-icon {
  margin-right: 10px;
}

.baritems {
  padding-top: 140px;
  padding-left: 20px;
  height: 100vh;
}

.first-item {
  background-color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 12px;
  margin-left: -13px;
  border-radius: 15px 0px 0px 15px;
  margin-top: 30px;
}

.seconditem {
  margin-top: 30px;
}

.brand-name {
  margin-left: 5px;
  padding-top: 10px;
  font-family: "Poppins";
  font-style: normal;
  font-size: 24px;
  font-weight: 600;
  /* letter-spacing: 0.05em; */
  color: #000;
}

.header-logo {
  justify-content: center;
  align-items: baseline;
  display: flex;

}

.account-details {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.table-dashboard {
  overflow-x: auto;
}

.table-head {
  background-color: white;
  /* border-radius: 20px; */
  font-family: "Poppins";
  font-weight: 600;
  padding-top: 5px;
  padding-left: 12px;
  padding-bottom: 6px;
  font-size: 14px;
}

.table-component {
  border-bottom: 10px white solid;
  color: rgba(80, 79, 79, 1);
  font-family: "Poppins";
  font-weight: 400;
  font-size: 13px;
}

.table-component:nth-child(even) {
  background-color: #FFFFFF;
}

.table-components {
  color: rgba(80, 79, 79, 1);
  font-family: "Poppins";
  font-weight: 400;
  font-size: 13px;
}

.fulltable {
  /* margin-top: 15px; */
  border: 10px white solid;
  /* border-radius: 25px; */
}

#check-box {
  margin-left: 15px;
}

.checkbox-thead {
  margin-left: 10px;
}

.first-col {
  margin-left: 5px;
}

.table-row {
  margin-right: 0 !important;
}

.row-margins {
  margin-left: 5px !important;
}

.image-margins {
  margin-top: 5px !important;
}

.last-col {
  border-right: none !important;
}

.last-row {
  justify-content: flex-end;
  display: flex;
  margin-right: 40px;
}

.brand-text {
  font-weight: bolder;
}

.small {
  flex-grow: 1;
}

.small-2 {
  flex-grow: 2;
}

.medium {
  flex-grow: 3;
}

.column-sizing {
  display: flex;
  flex-direction: column;
  word-break: break-word;
}

.large {
  flex-grow: 5;
}

.borderline {
  border-right: 2px rgba(206, 206, 206, 1) SOLID;
  padding-top: 10px;
}

.borderlines {
  border-right: 2px rgba(206, 206, 206, 1) SOLID;
}

.borderlin {
  padding-top: 10px;
}

.mt-5 {
  margin-top: 3rem !important;
  margin-left: 15px;
}

.pendi {
  color: #1549d6;
}

/* .pending-box {
  position: relative;
} */

.pendiimage {
  padding-left: 5px;
  cursor: pointer;
}

#secondbtn {
  border-color: rgba(206, 206, 206, 1) !important;
}

#secondbtn:hover {
  background: #1549d6;
}

#thirdbtnn {
  border-color: rgba(206, 206, 206, 1) !important;
}

#thirdbtnn:hover {
  background: #1549d6;
}

#firstbtnn {
  background: #1549d6;
  margin-right: 15px;
  border: none;
  box-shadow: none !important;
}

#nextbtn {
  background: #1549d6;
  border: none;
  box-shadow: none !important;
  margin-right: 15px;
}

#backbtn {
  background: #1549d6;
  border: none;
  box-shadow: none !important;
  margin-right: 15px;
}

#secondbtn {
  margin-right: 15px;
  box-shadow: none !important;
}

#thirdbtnn {
  margin-right: 15px;
}

.NavvBar {
  background-color: white;
}

.dot {
  margin-left: 4px;
}

.dot2 {
  margin-left: 8px;
}

.fil-name {
  font-family: "Poppins";
  font-weight: 400;
  margin-left: 5px;
  font-size: 13px;
}

.btn-filter {
  box-shadow: 0px 1px 5px 2px whitesmoke;
  color: black !important;
  background-color: white;
  border-color: white;
  margin-top: 10px;
}

.btn-filter:hover {
  background: rgba(55, 177, 200, 1);
  border: none;
}

#app-rej {
  color: black !important;
  background-color: white !important;
  border-color: white !important;
  box-shadow: 0px 1px 5px 2px whitesmoke;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  padding: 5px 20px;
}

.approve {
  border-bottom: 2px rgba(206, 206, 206, 1) solid;
  color: rgba(55, 200, 151, 1);
  font-family: "Poppins";
  font-weight: 400;
  font-size: 13px;
  padding: 5px;
  background-color: #FFF;
  outline: none;
  border: none;
}

.approve-btn {
  flex-direction: column;
  align-items: center;
}


.reject {
  color: rgba(200, 55, 104, 1);
  font-size: 13px;
  font-family: "Poppins";
  font-weight: 400;
  padding: 5px;
  background-color: #FFF;
  outline: none;
  border: none;
}

.flagged {
  color: rgb(253, 87, 4);
  font-size: 13px;
  font-family: "Poppins";
  font-weight: 400;
  padding: 5px;
  background-color: #FFF;
  outline: none;
  border: none;
  min-width: 80px;
}

.radial-code {
  padding-top: 13px;
  font-family: "Poppins ";
  font-style: italic;
  font-size: 13px;
  font-weight: 400;
  margin-top: 5px;
  padding-right: 5px;
}

#formm {
  border-radius: 15px;
  margin-top: 8px;
}

.radial-foto {
  padding-top: 5px;
}

.radial-logo {
  margin-left: 120px;
}

.arrow {
  padding-left: 5px;
}

.next {
  font-size: 18px;
  font-weight: 400;
  font-family: "Poppins";
}

#fourthbtnn:hover {
  background-color: rgb(83, 98, 212);
}

.dropdown-toggle::after {
  display: none;
}

.drop-box {
  box-shadow: 0px 1px 5px 2px whitesmoke;
  padding: 6px;
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 20px !important;
  background-color: white;
  border-color: white;
}

.border-dot {
  border-bottom: 2px rgba(206, 206, 206, 1) dotted;
  font-weight: 400;
  font-family: "Poppins";
  font-size: 15px;
  color: rgba(80, 79, 79, 1);
  padding-bottom: 10px;
}

.border-dots {
  font-weight: 400;
  font-family: "Poppins";
  font-size: 15px;
  color: rgba(80, 79, 79, 1);
}

.dropdown-menu {
  min-width: 0px !important;
}

.header-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 0px 0 0px 30px;
}

.search-bar-cont {
  display: flex;
  justify-content: center;
  width: 40%;
  align-items: center;
}

.withsearchBrand {
  width: 80% !important;
}

.searchBarCont {
  position: relative;
  margin-right: 15px
}

.withsearch {
  display: flex;
  justify-content: center;
  width: 50%;
}

.search-bar {
  border: 1px solid #CECECE;
  border-radius: 5px;
  width: 100%;
  outline: none;
  padding: 10px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
}

;

.user-profile {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.user-profile-text {
  margin-right: 10px;
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 27px;
  color: #504F4F;
}

.user-profile-brand-name {
  margin-right: 10px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
}

.react-datepicker-wrapper {
  width: 50%;
}

.react-datepicker__input-container,
.react-datepicker__input-container input {
  width: 100%;
  height: 58px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.MuiCircularProgress-colorPrimary {
  color: #1549d6 !important;
}

.dashboard-filters {
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
}

.dashboard-filters-btn {
  margin-left: 10px;
  background-color: #1549d6;
  border-radius: 5px;
  color: #FFF;
  outline: none;
  border: none;
  width: 10%;
  min-width: 150px;
  padding: 5px;
  opacity: 0.5;
}

.dashboard-filters-btn-active {
  opacity: 1;
}

.css-1to7aaw-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected {
  background-color: #1549d6 !important;
  color: #FFF !important;
}

:root {
  --code-color: darkred;
  --code-bg-color: #aaaaaa;
  --code-font-size: 14px;
  --code-line-height: 1.4;
  --scroll-bar-color: #c5c5c5;
  --scroll-bar-bg-color: inherit;
}


::-webkit-scrollbar-corner {
  background: rgba(0, 0, 0, 0.5);
}

* {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll-bar-color) var(--scroll-bar-bg-color);
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

*::-webkit-scrollbar-track {
  background: var(--scroll-bar-bg-color);
}

*::-webkit-scrollbar-thumb {
  background-color: var(--scroll-bar-color);
  border-radius: 10px;
  border: 3px solid var(--scroll-bar-bg-color);
}


@media only screen and (max-width: 600px) {
  .header-content {
    flex-direction: column;
    align-items: flex-start;
    padding: 0 15px;
  }

  .account-details {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
  }

  .header-logo {
    width: 100%;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .search-bar-cont {
    width: 80%;
    margin-top: 20px;
  }

  .withsearchBrand {
    width: 80% !important;
  }

  .searchBarCont {
    margin-top: 20px;
    margin-right: 0px;
    width: 80% !important;

  }

  .withsearch {
    flex-direction: column;
    width: 100%;
  }

  .dashboard-filters {
    flex-direction: column;
    justify-content: space-between;
  }

  .dashboard-filters-btn {
    min-width: 85px;
    margin: 10px 0;
  }

  .table-full {
    width: 1200px;
  }

}



.showrules {
  color: black !important;
  background-color: white !important;
  border-color: white !important;
  box-shadow: 0px 1px 5px 2px whitesmoke;
  margin-top: 10px;
  padding: 10px 10px 2px 15px;
  text-align: left;
  width: 340px;
  font-size: 17px;
  font-weight: 500;
}

.showrules p {
  margin-bottom: 10px;
}

.texttheme {
  font-size: 20px;
  font-style: normal;
  text-align: center;
  font-family: Poppins;
  font-weight: normal;
}

.isNetwork2 {
  height: 22px;
  width: 22px;
  position: absolute;
  right: 60px;
  top: 37px;
  border-color: red !important;
}

.handle {
  color: #000000;
  font-size: 20px;
  font-style: normal;
  font-family: Poppins;
  font-weight: 400;
  margin: 20px 0 0 10px;
  padding: 0;

}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAGA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;;AAEf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;;AAGA;EACE,4BAA4B;EAC5B,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AAGjB;;AAAA;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;AAChC;;;AAGA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,mEAAmE;AACrE;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,4CAA4C;AAC9C;;;AAGA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;;EAEvB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;AAEF;;;;AAIA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;;AAEZ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital@1&display=swap\");\n\nbody {\n  background: rgba(247, 247, 247, 1);\n}\n\n.sidebar {\n  background-color: #1549d6;\n  min-width: 70px;\n  height: auto;\n}\n\n.out-of-funds-btn {\n  background-color: rgba(255, 0, 0, 1);\n  border-radius: 5px;\n  color: #fff;\n  outline: none;\n  border: none;\n  text-align: center;\n  width: 20%;\n  min-width: fit-content;\n  font-weight: bold;\n  text-decoration: none;\n  padding: 10px;\n  font-size: 1em;\n}\n\n.out-of-funds-btn:hover {\n  background-color: rgba(220, 0, 0, 1);\n  color: #fff;\n}\n\n.reload-icon {\n  margin-right: 10px;\n}\n\n.baritems {\n  padding-top: 140px;\n  padding-left: 20px;\n  height: 100vh;\n}\n\n.first-item {\n  background-color: white;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 12px;\n  margin-left: -13px;\n  border-radius: 15px 0px 0px 15px;\n  margin-top: 30px;\n}\n\n.seconditem {\n  margin-top: 30px;\n}\n\n.brand-name {\n  margin-left: 5px;\n  padding-top: 10px;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-size: 24px;\n  font-weight: 600;\n  /* letter-spacing: 0.05em; */\n  color: #000;\n}\n\n.header-logo {\n  justify-content: center;\n  align-items: baseline;\n  display: flex;\n\n}\n\n.account-details {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.table-dashboard {\n  overflow-x: auto;\n}\n\n.table-head {\n  background-color: white;\n  /* border-radius: 20px; */\n  font-family: \"Poppins\";\n  font-weight: 600;\n  padding-top: 5px;\n  padding-left: 12px;\n  padding-bottom: 6px;\n  font-size: 14px;\n}\n\n.table-component {\n  border-bottom: 10px white solid;\n  color: rgba(80, 79, 79, 1);\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 13px;\n}\n\n.table-component:nth-child(even) {\n  background-color: #FFFFFF;\n}\n\n.table-components {\n  color: rgba(80, 79, 79, 1);\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 13px;\n}\n\n.fulltable {\n  /* margin-top: 15px; */\n  border: 10px white solid;\n  /* border-radius: 25px; */\n}\n\n#check-box {\n  margin-left: 15px;\n}\n\n.checkbox-thead {\n  margin-left: 10px;\n}\n\n.first-col {\n  margin-left: 5px;\n}\n\n.table-row {\n  margin-right: 0 !important;\n}\n\n.row-margins {\n  margin-left: 5px !important;\n}\n\n.image-margins {\n  margin-top: 5px !important;\n}\n\n.last-col {\n  border-right: none !important;\n}\n\n.last-row {\n  justify-content: flex-end;\n  display: flex;\n  margin-right: 40px;\n}\n\n.brand-text {\n  font-weight: bolder;\n}\n\n.small {\n  flex-grow: 1;\n}\n\n.small-2 {\n  flex-grow: 2;\n}\n\n.medium {\n  flex-grow: 3;\n}\n\n.column-sizing {\n  display: flex;\n  flex-direction: column;\n  word-break: break-word;\n}\n\n.large {\n  flex-grow: 5;\n}\n\n.borderline {\n  border-right: 2px rgba(206, 206, 206, 1) SOLID;\n  padding-top: 10px;\n}\n\n.borderlines {\n  border-right: 2px rgba(206, 206, 206, 1) SOLID;\n}\n\n.borderlin {\n  padding-top: 10px;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n  margin-left: 15px;\n}\n\n.pendi {\n  color: #1549d6;\n}\n\n/* .pending-box {\n  position: relative;\n} */\n\n.pendiimage {\n  padding-left: 5px;\n  cursor: pointer;\n}\n\n#secondbtn {\n  border-color: rgba(206, 206, 206, 1) !important;\n}\n\n#secondbtn:hover {\n  background: #1549d6;\n}\n\n#thirdbtnn {\n  border-color: rgba(206, 206, 206, 1) !important;\n}\n\n#thirdbtnn:hover {\n  background: #1549d6;\n}\n\n#firstbtnn {\n  background: #1549d6;\n  margin-right: 15px;\n  border: none;\n  box-shadow: none !important;\n}\n\n#nextbtn {\n  background: #1549d6;\n  border: none;\n  box-shadow: none !important;\n  margin-right: 15px;\n}\n\n#backbtn {\n  background: #1549d6;\n  border: none;\n  box-shadow: none !important;\n  margin-right: 15px;\n}\n\n#secondbtn {\n  margin-right: 15px;\n  box-shadow: none !important;\n}\n\n#thirdbtnn {\n  margin-right: 15px;\n}\n\n.NavvBar {\n  background-color: white;\n}\n\n.dot {\n  margin-left: 4px;\n}\n\n.dot2 {\n  margin-left: 8px;\n}\n\n.fil-name {\n  font-family: \"Poppins\";\n  font-weight: 400;\n  margin-left: 5px;\n  font-size: 13px;\n}\n\n.btn-filter {\n  box-shadow: 0px 1px 5px 2px whitesmoke;\n  color: black !important;\n  background-color: white;\n  border-color: white;\n  margin-top: 10px;\n}\n\n.btn-filter:hover {\n  background: rgba(55, 177, 200, 1);\n  border: none;\n}\n\n#app-rej {\n  color: black !important;\n  background-color: white !important;\n  border-color: white !important;\n  box-shadow: 0px 1px 5px 2px whitesmoke;\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  padding: 5px 20px;\n}\n\n.approve {\n  border-bottom: 2px rgba(206, 206, 206, 1) solid;\n  color: rgba(55, 200, 151, 1);\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 13px;\n  padding: 5px;\n  background-color: #FFF;\n  outline: none;\n  border: none;\n}\n\n.approve-btn {\n  flex-direction: column;\n  align-items: center;\n}\n\n\n.reject {\n  color: rgba(200, 55, 104, 1);\n  font-size: 13px;\n  font-family: \"Poppins\";\n  font-weight: 400;\n  padding: 5px;\n  background-color: #FFF;\n  outline: none;\n  border: none;\n}\n\n.flagged {\n  color: rgb(253, 87, 4);\n  font-size: 13px;\n  font-family: \"Poppins\";\n  font-weight: 400;\n  padding: 5px;\n  background-color: #FFF;\n  outline: none;\n  border: none;\n  min-width: 80px;\n}\n\n.radial-code {\n  padding-top: 13px;\n  font-family: \"Poppins \";\n  font-style: italic;\n  font-size: 13px;\n  font-weight: 400;\n  margin-top: 5px;\n  padding-right: 5px;\n}\n\n#formm {\n  border-radius: 15px;\n  margin-top: 8px;\n}\n\n.radial-foto {\n  padding-top: 5px;\n}\n\n.radial-logo {\n  margin-left: 120px;\n}\n\n.arrow {\n  padding-left: 5px;\n}\n\n.next {\n  font-size: 18px;\n  font-weight: 400;\n  font-family: \"Poppins\";\n}\n\n#fourthbtnn:hover {\n  background-color: rgb(83, 98, 212);\n}\n\n.dropdown-toggle::after {\n  display: none;\n}\n\n.drop-box {\n  box-shadow: 0px 1px 5px 2px whitesmoke;\n  padding: 6px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  border-radius: 20px !important;\n  background-color: white;\n  border-color: white;\n}\n\n.border-dot {\n  border-bottom: 2px rgba(206, 206, 206, 1) dotted;\n  font-weight: 400;\n  font-family: \"Poppins\";\n  font-size: 15px;\n  color: rgba(80, 79, 79, 1);\n  padding-bottom: 10px;\n}\n\n.border-dots {\n  font-weight: 400;\n  font-family: \"Poppins\";\n  font-size: 15px;\n  color: rgba(80, 79, 79, 1);\n}\n\n.dropdown-menu {\n  min-width: 0px !important;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n  padding: 0px 0 0px 30px;\n}\n\n.search-bar-cont {\n  display: flex;\n  justify-content: center;\n  width: 40%;\n  align-items: center;\n}\n\n.withsearchBrand {\n  width: 80% !important;\n}\n\n.searchBarCont {\n  position: relative;\n  margin-right: 15px\n}\n\n.withsearch {\n  display: flex;\n  justify-content: center;\n  width: 50%;\n}\n\n.search-bar {\n  border: 1px solid #CECECE;\n  border-radius: 5px;\n  width: 100%;\n  outline: none;\n  padding: 10px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: normal;\n  font-size: 20px;\n}\n\n;\n\n.user-profile {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.user-profile-text {\n  margin-right: 10px;\n  font-family: Poppins;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 27px;\n  color: #504F4F;\n}\n\n.user-profile-brand-name {\n  margin-right: 10px;\n  font-family: Poppins;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 27px;\n}\n\n.react-datepicker-wrapper {\n  width: 50%;\n}\n\n.react-datepicker__input-container,\n.react-datepicker__input-container input {\n  width: 100%;\n  height: 58px;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.MuiCircularProgress-colorPrimary {\n  color: #1549d6 !important;\n}\n\n.dashboard-filters {\n  display: flex;\n  padding: 20px;\n  justify-content: center;\n  align-items: center;\n}\n\n.dashboard-filters-btn {\n  margin-left: 10px;\n  background-color: #1549d6;\n  border-radius: 5px;\n  color: #FFF;\n  outline: none;\n  border: none;\n  width: 10%;\n  min-width: 150px;\n  padding: 5px;\n  opacity: 0.5;\n}\n\n.dashboard-filters-btn-active {\n  opacity: 1;\n}\n\n.css-1to7aaw-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected {\n  background-color: #1549d6 !important;\n  color: #FFF !important;\n}\n\n:root {\n  --code-color: darkred;\n  --code-bg-color: #aaaaaa;\n  --code-font-size: 14px;\n  --code-line-height: 1.4;\n  --scroll-bar-color: #c5c5c5;\n  --scroll-bar-bg-color: inherit;\n}\n\n\n::-webkit-scrollbar-corner {\n  background: rgba(0, 0, 0, 0.5);\n}\n\n* {\n  scrollbar-width: thin;\n  scrollbar-color: var(--scroll-bar-color) var(--scroll-bar-bg-color);\n}\n\n/* Works on Chrome, Edge, and Safari */\n*::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n*::-webkit-scrollbar-track {\n  background: var(--scroll-bar-bg-color);\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: var(--scroll-bar-color);\n  border-radius: 10px;\n  border: 3px solid var(--scroll-bar-bg-color);\n}\n\n\n@media only screen and (max-width: 600px) {\n  .header-content {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 0 15px;\n  }\n\n  .account-details {\n    align-items: flex-start;\n    display: flex;\n    flex-direction: column;\n    margin-top: 20px;\n  }\n\n  .header-logo {\n    width: 100%;\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n\n  .search-bar-cont {\n    width: 80%;\n    margin-top: 20px;\n  }\n\n  .withsearchBrand {\n    width: 80% !important;\n  }\n\n  .searchBarCont {\n    margin-top: 20px;\n    margin-right: 0px;\n    width: 80% !important;\n\n  }\n\n  .withsearch {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .dashboard-filters {\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  .dashboard-filters-btn {\n    min-width: 85px;\n    margin: 10px 0;\n  }\n\n  .table-full {\n    width: 1200px;\n  }\n\n}\n\n\n\n.showrules {\n  color: black !important;\n  background-color: white !important;\n  border-color: white !important;\n  box-shadow: 0px 1px 5px 2px whitesmoke;\n  margin-top: 10px;\n  padding: 10px 10px 2px 15px;\n  text-align: left;\n  width: 340px;\n  font-size: 17px;\n  font-weight: 500;\n}\n\n.showrules p {\n  margin-bottom: 10px;\n}\n\n.texttheme {\n  font-size: 20px;\n  font-style: normal;\n  text-align: center;\n  font-family: Poppins;\n  font-weight: normal;\n}\n\n.isNetwork2 {\n  height: 22px;\n  width: 22px;\n  position: absolute;\n  right: 60px;\n  top: 37px;\n  border-color: red !important;\n}\n\n.handle {\n  color: #000000;\n  font-size: 20px;\n  font-style: normal;\n  font-family: Poppins;\n  font-weight: 400;\n  margin: 20px 0 0 10px;\n  padding: 0;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
